import getApiClient from '@/plugins/api-client'

export default {
  loadUser() {
    const self = this,
      userId = self.$route.params.id,
      api = getApiClient(self.$store)

    api.get(`users/${userId}`)
      .then(result => {
        self.user = result.data
      })
      .catch(error => {
        console.log(error)
      })
  },

  getUserRole(user) {
    let result = ''

    if (user.roles.includes('ROLE_ADMIN')) {
      result = 'Admin'
    }

    if (user.roles.includes('ROLE_CONTRACTOR')) {
      result = 'Contratante'
    }

    if (user.roles.includes('ROLE_PROFESSIONAL')) {
      result = 'Prestador'
    }

    return result
  },

  getUserGender(user) {
    let result = ''

    switch (user.gender) {
      case 'F':
        result = 'Feminino'
        break;
      case 'M':
        result = 'Masculino'
        break;
      case 'T':
        result = 'Transgênero'
        break;
    }

    return result
  },

  getProfileCategoryLabel(category) {
    let item = this.availableJobCategories.filter(item => {
      return item.code === category
    })

    return item[0]?.label ?? category
  },

  getEthnicityLabel(ethnicity) {
    let item = this.availableEthnicities.filter(item => {
      return item.code === ethnicity
    })

    return item[0]?.ethnicity ?? ethnicity
  },

  getHairColorLabel(hairColor) {
    let item = this.availableHairColors.filter(item => {
      return item.code === hairColor
    })

    return item[0]?.color ?? hairColor
  },

  getJobTypeLabel(jobType) {
    let item = this.availableJobTypes.filter(item => {
      return item.code === jobType
    })

    return item[0]?.label ?? jobType
  },

  updateSymplaParticipation(symplaParticipation) {
    const self = this,
      api = getApiClient(self.$store)

    self.$store.commit('startLoading')
    api.patch(`${symplaParticipation['@id']}/update_progress`, {
      percentCompleted: symplaParticipation.percentCompleted,
    }, {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  toggleSearchVisibility(hiddenFromSearch) {
    const self = this,
      api = getApiClient(self.$store)

    self.$store.commit('startLoading')
    api.patch(`users/${self.user.id}/search_visibility`, {
      hiddenFromSearch
    }, {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
      .then(() => {
        self.user.hiddenFromSearch = hiddenFromSearch
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  }
}
